// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__krqRf","fontSizeSelector":"Settings_fontSizeSelector__D+S-+"};